import styled from '@emotion/styled';
import { nike } from '@nike/nike-design-tokens';
import { ModalStyled } from '@nike/nike-design-system-components';
import { mobileOnly, focusRingStyle } from '../../utils/sharedStyles';
const {
  podiumCdsIconButtonColorBgSecondaryHover,
  podiumCdsColorTextPrimaryOnDark,
  podiumCdsIconButtonColorBgSecondary,
  podiumCdsColorTextPrimaryOnLight,
} = nike;

const koreaLegalFooter = 'korea-legal-footer';
export const section = `${koreaLegalFooter}-section`;
export const inlineButton = `${koreaLegalFooter}-inline-button`;
export const link = `${koreaLegalFooter}-link`;

export const KoreanLegalFooterContainer = styled.div`
  color: var(--podium-cds-color-text-secondary);
  display: flex;
  gap: 12px;
  font-weight: var(--podium-cds-font-weight-regular);
  font-size: var(--podium-cds-font-size-xs);
  font-family: Noto Sans KR;
  @media (${mobileOnly}) {
    flex-direction: column;
  }
  .${section} {
    width: 50%;
    @media (${mobileOnly}) {
      width: 100%;
    }
  }
  .${inlineButton} {
    display: inline-block;
    font-size: var(--podium-cds-font-size-xs);
  }
  .${link} {
    font-family: Noto Sans KR;
    font-weight: var(--podium-cds-font-weight-regular);
    text-decoration: underline;
    text-decoration-color: var(--podium-cds-color-text-secondary);
    color: var(--podium-cds-color-text-secondary);
    &:hover {
      color: var(--podium-cds-color-text-primary);
    }
  }
`;

export const KoreanModalInnerText = styled.p`
  font-family: inherit;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  margin: 4px;
`;

export const koreaModalButton = 'korea-modal-button';
export const koreaModalMain = 'korea-modal-main';
export const KoreanLegalModal = styled(ModalStyled)`
  .${koreaModalButton} {
    // ncss 4.2 compatibility
    color: ${podiumCdsColorTextPrimaryOnDark};
    ${focusRingStyle}
  }

  // ncss 4.2 compatibility
  .${koreaModalMain} > .close-btn-container > button {
    &:before {
      border: none;
    }
    background-color: ${podiumCdsIconButtonColorBgSecondary};
    color: ${podiumCdsColorTextPrimaryOnLight};
    ${focusRingStyle}
    &:hover:not(:disabled),
    &:active {
      background-color: ${podiumCdsIconButtonColorBgSecondaryHover};
    }
  }
`;

export const KoreanModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
